module.exports = __webpack_public_path__ + "media/images/admin/btn_back-62fd6ce8cf9000d1642c210732fc13dc.png";